import { Reducer } from 'redux';

import { ModalFilterState, ModalFilterTypes } from './types';

const INITIAL_STATE: ModalFilterState = {
  openModal: false,
  error: false,
  loading: false,
};

const reducer: Reducer<ModalFilterState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // SET MODAL OPEN
    case ModalFilterTypes.SET_OPEN_MODAL:
      return {
        ...state,
        loading: false,
        error: false,
        openModal: action.payload.openModal,
      };

    default:
      return state;
  }
};

export default reducer;
